import { Link } from "react-router-dom";
import { articles } from "@/mocks/articles";

export default function LatestContent() {
  const latestArticles = articles.filter((a) => a.isNew).slice(0, 6);
  const displayArticles = latestArticles.length >= 6 ? latestArticles : articles.slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">
              <i className="ri-timer-flash-line text-accent-500 mr-2"></i>
              最新<span className="text-primary-500">内容</span>
            </h2>
            <p className="text-sm text-foreground-500 mt-2">实时更新，新鲜爆料不错过</p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {displayArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group flex flex-col sm:flex-row gap-4 p-4 md:p-5 rounded-xl bg-background-100 hover:bg-background-200/70 transition-all duration-300 cursor-pointer ${
                index === 0 ? "md:col-span-2" : ""
              }`}
            >
              <div
                className={`relative rounded-lg overflow-hidden flex-shrink-0 ${
                  index === 0
                    ? "w-full sm:w-[360px] aspect-video"
                    : "w-full sm:w-[200px] aspect-video sm:aspect-[4/3]"
                }`}
              >
                <img
                  src={article.thumbnail}
                  alt={article.title}
                  title={`黑料吃瓜最新视频 - ${article.title}`}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded-full bg-black/60 text-white text-xs">
                  {article.duration}
                </div>
                {article.isNew && (
                  <div className="absolute top-2 left-2 px-2 py-0.5 rounded-full bg-accent-500 text-white text-xs font-bold">
                    NEW
                  </div>
                )}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-2">
                  <span className="px-2.5 py-0.5 rounded-full bg-secondary-100 text-secondary-700 text-xs whitespace-nowrap">
                    {article.category}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-2 mb-3">
                  {article.title}
                </h3>
                <p className="text-sm text-foreground-500 line-clamp-2 mb-3 leading-relaxed">
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 text-xs text-foreground-400">
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {article.views >= 10000
                      ? `${(article.views / 10000).toFixed(1)}万次播放`
                      : `${article.views}次播放`}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {article.comments}条评论
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}